import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';


const ValidationErrorMessage = props => {

    const {
        isVisible,
        messageText = false,
        messageTextReplacements,
        errorClasses
    } = props;

    return (
        <div className="grid-row margin-tb-5">
            <span className={`tablet:grid-offset-4 ${isVisible ? 'shown' : 'hidden'} error--msg ${errorClasses ? errorClasses.join(' ') : ''}`} aria-live='assertive'>
                <em>
                    <FontAwesomeIcon icon="exclamation"/>
                </em>
                <FormattedMessage id={messageText === false ? 'common.no_text' : messageText} values={messageTextReplacements}/>
            </span>
        </div>
    );
};

export default ValidationErrorMessage;
